export const ENV = "production";
export const SERVER_ENDPOINT = ENV === 'development' ? "http://localhost:3001" : "https://valvemasterapp.aquestia.com";
export const ADMIN_PERMISSIONS = '8';
export const MANAGER_PERMISSIONS = '2';
export const USER_PERMISSIONS = '1';